module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DefaultLayout', [_c('div', {
    staticClass: "rounded-md h-full px-5 py-3"
  }, [(_vm.loading_ld || _vm.getCourseLoading) ? _c('div', {
    key: "loading",
    staticClass: "h-full mt-6"
  }, [_c('div', {
    staticClass: "flex flex-col justify-center items-center"
  }, [_c('p', {
    staticClass: "mb-2.5"
  }, [_vm._v("Loading RoundTable")]), _vm._v(" "), _c('pl-spinner')], 1)]) : _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.isFullscreen ? _vm.isFullscreen = !_vm.isFullscreen : _vm.isFullscreen = _vm.isFullscreen
      }
    }
  }, [_c('header', {
    staticClass: "mb-3 relative"
  }, [_c('div', {
    staticClass: "flex flex-col md:flex-row justify-between space-y-2 md:space-y-0 md:items-center"
  }, [_c('div', {
    staticClass: "flex space-x-3 items-center"
  }, [(_vm.rt_integration) ? _c('div', {
    staticClass: "ml-2"
  }, [_c('a', {
    attrs: {
      "href": _vm.assignmentUrl,
      "target": "blank"
    }
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": _vm.assignmentIcon,
      "width": "22px",
      "height": "22px"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.getCurrentDiscussion.sequence_id !== null) ? _c('DropdownMenu', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function() {
        return [_c('button', {
          staticClass: "bg-indigo-500 rounded-full py-2 px-4 flex items-center justify-between space-x-2"
        }, [_c('img', {
          staticClass: "w-4 h-4",
          attrs: {
            "src": "/static/roundtable_icons/sequence_icon.svg"
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "fa-solid text-xs fa-chevron-down text-indigo-50 hover:text-indigo-100"
        })])]
      },
      proxy: true
    }, {
      key: "menu-content",
      fn: function() {
        return [_c('ul', {
          staticClass: "absolute z-50 bg-white border border-solid border-gray-200 max-w-lg rounded-lg mt-2 shadow-sm"
        }, _vm._l((_vm.getCurrentDiscussion.roundtables_sequence), function(roundtable, index) {
          return _c('li', {
            key: index,
            staticClass: "border-b border-gray-200 py-2 px-3 hover:bg-gray-100 cursor-pointer",
            class: [{
              'border-none': index + 1 === _vm.getCurrentDiscussion.roundtables_sequence.length
            }, {
              'bg-gray-100': roundtable.id === _vm.$route.params.liveDiscussionID
            }],
            on: {
              "click": function($event) {
                return _vm.handleClickSequenceRoundTable(roundtable.id, roundtable.type)
              }
            }
          }, [_c('div', {
            staticClass: "flex justify-start items-center space-x-2"
          }, [_c('div', {
            staticClass: "w-7 h-7"
          }, [_c('div', {
            staticClass: "flex items-center justify-center rounded-full h-7 w-7",
            class: [{
              'bg-blue': roundtable.type === 'written' || roundtable.type === 'roundtable',
              'bg-green-light': roundtable.type === 'verbal' || roundtable.type === 'live_discussion'
            }]
          }, [_c('img', {
            staticClass: "w-3 h-3",
            class: [{
              'w-3 h-3': roundtable.type === 'written'
            }, {
              'w-3 pt-0.5 h-3': roundtable.type === 'verbal'
            }],
            attrs: {
              "src": roundtable.type === 'written' || roundtable.type === 'roundtable' ? '/static/roundtable_icons/written_icon.svg' : '/static/roundtable_icons/verbal_icon.svg'
            }
          })])]), _vm._v(" "), _c('h6', {
            staticClass: "truncate"
          }, [_vm._v(_vm._s(roundtable.title))])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 1696909075)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-2xl font-extrabold font-manrope cursor-default text-gray-800 antialiased font-bold",
    attrs: {
      "title": _vm.getCurrentDiscussion.title
    }
  }, [_vm._v("\n              " + _vm._s(_vm.getCurrentDiscussion.title) + "\n            ")]), _vm._v(" "), (_vm.getCurrentDiscussion.sequence_id) ? _c('div', {
    staticClass: "bg-indigo-100 text-xs border border-solid border-indigo-500 text-indigo-500 rounded-full px-2 py-0.5"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.current_sequence_number + 1))]), _vm._v(" "), _c('span', {
    staticClass: "ml-0.5 mr-1"
  }, [_vm._v("of")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getCurrentDiscussion.roundtables_sequence.length))])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [(_vm.showQuestionIcon) ? _c('div', {
    staticClass: "cursor-pointer text-base text-gray-600",
    on: {
      "click": _vm.showRTWelcomeModal
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-base"
  })]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "px-5 font-manrope py-2 bg-pinky hover:bg-pinky-dark rounded-full text-white font-semibold text-sm disabled:opacity-50",
    on: {
      "click": function($event) {
        _vm.isInviteStudentModalOpen = true
      }
    }
  }, [_c('span', {
    staticClass: "truncate"
  }, [_vm._v("Invite Students")])]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', [_c('LiveDiscussionMenu', {
    on: {
      "showDuplicateModal": function($event) {
        _vm.show_duplicate_modal = true
      },
      "showEditLrtModal": function($event) {
        _vm.show_edit_lrt_modal = true
      },
      "showFollowUp": function (type) { return _vm.handleOpenStartFollowUP(type); },
      "rtIntegrationAssignment": function (value) { return (_vm.show_integrations_modal = value); },
      "handleDeleteRoundTable": function($event) {
        _vm.show_delete_live_rt_modal = true
      },
      "handleOpenExportData": function($event) {
        _vm.show_export_data_modal = true
      },
      "handleRemoveFromSequence": function($event) {
        _vm.is_to_remove_roundtable_from_sequence = true
      }
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "sm:flex sm:flex-row items-start space-x-1.5",
    class: {
      'absolute h-screen bg-gray-50 top-0 left-0 right-0 bottom-0 z-50 overflow-y-auto': _vm.isFullscreen
    }
  }, [_c('div', {
    staticClass: "flex flex-col tab-body rounded-lg w-full",
    attrs: {
      "id": "discussion-main"
    }
  }, [_c('header', {
    staticClass: "flex justify-between items-center w-full pt-2.5 pr-5",
    class: {
      'bg-white border border-solid border-gray-200 rounded-t-lg': !_vm.isFullscreen
    },
    attrs: {
      "id": "tabs"
    }
  }, [_c('div', {
    staticClass: "flex items-center rounded-t-lg overflow-x-auto font-manrope"
  }, [_c('div', {
    staticClass: "h-7 px-5 select-none cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'prompt'
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('prompt')
      }
    }
  }, [_vm._v("\n                Prompt\n              ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "h-7 select-none px-5 cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'settings'
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('settings')
      }
    }
  }, [_vm._v("\n                Settings\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h-7 select-none px-5 cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'discussion'
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('discussion')
      }
    }
  }, [_vm._v("\n                Discussion\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "h-7 select-none px-5 cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'transcriptions'
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('transcriptions')
      }
    }
  }, [_vm._v("\n                Transcription\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "h-7 px-5 select-none cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'summary'
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('summary')
      }
    }
  }, [_vm._v("\n                Summary\n              ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "h-7 select-none px-5 cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'individualSummary'
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('individualSummary')
      }
    }
  }, [_vm._v("\n                Table\n              ")]) : _vm._e()]), _vm._v(" "), (_vm.discussion_is_live && _vm.tab === 'discussion') ? _c('div', {
    staticClass: "h-7 rounded-md font-manrope -mt-2.5 flex items-center text-xs space-x-2 text-gray-700 px-2.5 py-1.5",
    staticStyle: {
      "margin-right": "-15px"
    }
  }, [_c('i', {
    staticClass: "fa-regular fa-clock"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.discussion_time))])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'prompt' && _vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "px-1 hover:underline text-center cursor-pointer py-0.5 -mt-2 rounded",
    on: {
      "click": function($event) {
        _vm.show_edit_lrt_modal = true
      }
    }
  }, [_c('span', [_vm._v("Edit Prompt")])]) : (_vm.tab === 'settings' && _vm.is_button_save_setting_enable === false) ? _c('div', {
    staticClass: "-mt-2 flex space-x-1 items-center"
  }, [_c('button', {
    staticClass: "sample flex items-center space-x-2 font-poppins text-blueGray-800 px-1 disabled:opacity-50",
    on: {
      "click": function($event) {
        _vm.is_confirm_settings_modal_open = true
      }
    }
  }, [_c('i', {
    staticClass: "fa-regular fa-floppy-disk text-base"
  }), _vm._v(" "), _c('span', {
    staticClass: "hover:underline"
  }, [_vm._v("Save Changes")])]), _vm._v(" "), (!_vm.is_button_save_setting_enable) ? _c('button', {
    staticClass: "sample hover:underline text-gray-500 px-1 disabled:opacity-50",
    on: {
      "click": _vm.forceRerender
    }
  }, [_vm._v("\n                Cancel\n              ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1 min-h-0 relative rounded-b-lg bg-white border-r border-l border-b border-solid border-gray-200"
  }, [(_vm.getCurrentDiscussion.id && _vm.component_to_render !== 'LDDiscussionTab') ? _c(_vm.component_to_render, {
    key: _vm.componentKey,
    ref: "childComponent",
    tag: "Component",
    staticClass: "flex flex-col flex-1 min-h-0 px-3 py-3",
    class: {
      'justify-between': _vm.isFullscreen && _vm.tab === 'discussion'
    },
    attrs: {
      "isFullscreen": _vm.isFullscreen
    },
    on: {
      "editAssessmentPoint": _vm.editAssessmentPoint,
      "deleteAssessmentPoint": _vm.deleteAssessmentPoint,
      "cancelSettingsChanges": _vm.forceRerender,
      "openSendNudge": _vm.openSendNudgeModal,
      "toggleFullscreen": _vm.toggleFullscreen,
      "handleSettingsChange": function (value) { return (_vm.is_button_save_setting_enable = value); }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isOpenParticipant && _vm.tab === 'discussion') ? _c('div', {
    staticClass: "absolute z-50 cursor-pointer -right-2.5 top-1/4 bg-white hover:bg-gray-50 border border-solid rounded-full w-7 h-7 border-gray-200 shadow"
  }, [_c('div', {
    staticClass: "flex justify-center text-gray-500 items-center h-full",
    staticStyle: {
      "font-size": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.onChangeSidebar(_vm.toogle_participations)
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid",
    class: {
      'fa-chevron-right': _vm.toogle_participations || _vm.toogle_notepad,
      'fa-chevron-left': !_vm.toogle_participations || !_vm.toogle_notepad
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'transcriptions' && _vm.getCurrentDiscussion.transcriptions && (_vm.isGenieRecapOpen || _vm.hasTeacherPermissionsInCourse || (!_vm.hasTeacherPermissionsInCourse && _vm.getCurrentDiscussion.genie_recap))) ? _c('div', {
    staticClass: "absolute z-50 cursor-pointer -right-2.5 top-96 bg-white hover:bg-gray-50 border border-solid rounded-full w-7 h-7 border-gray-200 shadow"
  }, [_c('div', {
    staticClass: "flex justify-center text-gray-500 items-center h-full",
    staticStyle: {
      "font-size": "10px"
    },
    on: {
      "click": function($event) {
        _vm.isGenieRecapOpen = !_vm.isGenieRecapOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid",
    class: {
      'fa-chevron-right': _vm.isGenieRecapOpen,
      'fa-chevron-left': !_vm.isGenieRecapOpen
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.getCurrentDiscussion.id) ? _c('LDDiscussionTab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.component_to_render === 'LDDiscussionTab'),
      expression: "component_to_render === 'LDDiscussionTab'"
    }],
    key: _vm.componentKey + 1,
    ref: "childComponent",
    tag: "Component",
    staticClass: "flex flex-col flex-1 min-h-0",
    class: {
      'justify-between': _vm.isFullscreen && _vm.tab === 'discussion'
    },
    attrs: {
      "joinedAudioDiscussion": _vm.joined_audio_discussion,
      "rtc": _vm.rtc,
      "screenRTC": _vm.screenRTC,
      "isFullscreen": _vm.isFullscreen
    },
    on: {
      "handleSettingsChange": function (value) { return (_vm.is_button_save_setting_enable = value); },
      "editAssessmentPoint": _vm.editAssessmentPoint,
      "deleteAssessmentPoint": _vm.deleteAssessmentPoint,
      "cancelSettingsChanges": _vm.forceRerender,
      "muteAudio": _vm.muteAudio,
      "unmuteAudio": _vm.unmuteAudio,
      "videoOff": _vm.videoOff,
      "videoOn": _vm.videoOn,
      "openSendNudge": _vm.openSendNudgeModal,
      "toggleFullscreen": _vm.toggleFullscreen
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.tab === 'discussion') ? _c('div', {
    staticClass: "flex flex-col h-full flex-grow overflow-y-auto relative overflow-x-hidden",
    class: {
      'sm:w-5/12 md:5/12 lg:w-4/12 xl:w-4/12 2xl:w-3/12': _vm.toogle_participations === true || _vm.isOpenParticipant || _vm.toogle_notepad === true,
      'max-h-container-participants-fullscreen': _vm.isFullscreen,
      'max-h-container-participants': !_vm.isFullscreen
    }
  }, [(_vm.toogle_participations === true) ? _c('div', [(!_vm.isOpenParticipant && _vm.hasTeacherPermissionsInCourse) ? _c('ListParticipants', {
    attrs: {
      "isFullscreen": _vm.isFullscreen
    },
    on: {
      "openSendNudge": _vm.openSendNudgeModal,
      "openParticipantSidebar": _vm.openParticipant,
      "setAsModerator": _vm.setAsModerator
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.toogle_participations === false) ? _c('div', [(!_vm.isOpenParticipant && _vm.hasTeacherPermissionsInCourse) ? _c('ListParticipantsCollapsed', {
    attrs: {
      "isFullscreen": _vm.isFullscreen
    },
    on: {
      "openSendNudge": _vm.openSendNudgeModal,
      "openParticipantSidebar": _vm.openParticipant,
      "setAsModerator": _vm.setAsModerator
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [(_vm.isOpenParticipant && _vm.hasTeacherPermissionsInCourse) ? _c('Participant', {
    attrs: {
      "userInformation": _vm.studentInformation,
      "isFullscreen": _vm.isFullscreen
    },
    on: {
      "backToParticipantsList": _vm.closeParticipation,
      "openCreateSuggestion": _vm.openNewSuggestion,
      "openImport": _vm.openImportSuggestions,
      "openDeleteSuggestion": _vm.openConfirmDeleteSuggestion,
      "openSendNudge": _vm.openSendNudgeModal
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.hasTeacherPermissionsInCourse && _vm.toogle_notepad === true) ? _c('div', [_c('DiscussionSidebarStudentNotes', {
    attrs: {
      "isFullscreen": _vm.isFullscreen
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tab === 'prompt' && !_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "h-full 2xl:w-5/12 xl:w-5/12 lg:w-7/12 md:w-7/12 w-full"
  }, [_c('PromptSideBarStudentNotepad', {
    staticClass: "h-full"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canShowGenieRecap) ? _c('div', {
    staticClass: "xl:w-4/12 lg:w-5/12 md:w-6/12 w-full sticky top-0 h-full max-h-screen overflow-y-auto"
  }, [_c('GenieRecapVerbal', {
    on: {
      "startFollowUp": _vm.handleStartFollowUp
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFullscreen) ? _c('button', {
    staticClass: "absolute bottom-5 right-5 w-14 h-14 bg-white hover:bg-gray-100 rounded-full shadow-md",
    on: {
      "click": function($event) {
        _vm.show_course_chat = true
      }
    }
  }, [_c('div', {
    staticClass: "text-gray-600 text-xl h-full relative flex justify-center items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-comments"
  }), _vm._v(" "), (_vm.message_notifications > 0) ? _c('div', {
    staticClass: "absolute top-0 right-0 h-3 w-3 rounded-full bg-pinky"
  }) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), (_vm.isOpenSendNudge === true) ? _c('ModalSendNudge', {
    attrs: {
      "userInformation": _vm.studentInformation
    },
    on: {
      "closeDialog": _vm.closeSendNudgeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenNewSuggestion === true) ? _c('ModalNewSuggestion', {
    attrs: {
      "suggestionToEdit": _vm.selectedSuggestion
    },
    on: {
      "close": function($event) {
        _vm.isOpenNewSuggestion = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenImportSuggestions) ? _c('ImportFeedbackTemplatesModal', {
    attrs: {
      "typeRoundtable": "live"
    },
    on: {
      "close": function($event) {
        _vm.isOpenImportSuggestions = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenDeleteSuggestion) ? _c('ModalDeleteSuggestion', {
    attrs: {
      "suggestion": _vm.selectedSuggestion
    },
    on: {
      "close": function($event) {
        _vm.isOpenDeleteSuggestion = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.isOpenModalDiscussionStatusChange === true &&
    !_vm.hasTeacherPermissionsInCourse
  ) ? _c('ModalDiscussionIsStarted', {
    on: {
      "close": function($event) {
        _vm.isOpenModalDiscussionStatusChange = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_RT_Welcome_modal) ? _c('roundTable-welcome-modal', {
    attrs: {
      "activityType": "live",
      "data": _vm.welcomeRoundTableData
    },
    on: {
      "close": _vm.closeRTWelcomeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_teacher_summary) ? _c('live-discussion-summary-page', {
    attrs: {
      "pageWidth": "1200px"
    },
    on: {
      "close": function($event) {
        _vm.show_teacher_summary = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_duplicate_modal) ? _c('duplicate-roundtable-modal', {
    attrs: {
      "is_live_roundtable": true
    },
    on: {
      "close": function($event) {
        _vm.show_duplicate_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.open_google_classroom_dialog) ? _c('integrations-connect-modal', {
    on: {
      "close": function($event) {
        _vm.open_google_classroom_dialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_integration_connected) ? _c('integration-connected-modal', {
    attrs: {
      "integration": _vm.integration
    },
    on: {
      "close": function($event) {
        _vm.is_integration_connected = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_point_creation_modal) ? _c('create-new-point-modal', {
    attrs: {
      "activityType": 'verbal',
      "tag": _vm.selected_point_tag,
      "rts": _vm.live_discussions_with_point,
      "assessment_scale": _vm.selected_point_scale
    },
    on: {
      "deleteAssessmentPoint": _vm.deleteAssessmentPoint,
      "close": function($event) {
        _vm.show_point_creation_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFollowUpOpen === true) ? _c('Draft', {
    attrs: {
      "id": _vm.selectedRoundTableToFollow.draftId,
      "type": _vm.selectedRoundTableToFollow.type,
      "isFollowUp": true
    },
    on: {
      "close": function($event) {
        _vm.isFollowUpOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_alert_assessment_changing) ? [_c('pl-dialog', {
    attrs: {
      "size": "confirm_size",
      "title": 'Heads up!',
      "disableOutsideClick": true,
      "showCloseButton": false
    },
    on: {
      "close": _vm.closeAssessmentChangingAlert
    }
  }, [_c('div', {
    staticClass: "px-6 flex flex-col pb-5"
  }, [_c('div', {
    staticClass: "flex-grow mb-6"
  }, [_c('div', [_c('p', {
    staticClass: "mb-4"
  }, [_vm._v("\n              Changing (or deleting) this assessment criteria for this\n              RoundTable will change (or delete) it for all of the other\n              RoundTables in this course that also use this criteria:\n            ")])]), _vm._v(" "), _c('ul', _vm._l((_vm.live_discussions_with_point), function(live_discussion) {
    return _c('li', {
      key: live_discussion.id,
      staticClass: "mb-1"
    }, [_c('span', {
      staticClass: "font-semibold font-poppins"
    }, [_vm._v("- " + _vm._s(live_discussion.title))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex w-full flex-col space-y-4"
  }, [_c('button', {
    staticClass: "bg-primary w-full hover:bg-primary-dark text-white rounded px-3 py-2",
    on: {
      "click": _vm.closeAssessmentChangingAlert
    }
  }, [_vm._v("\n            Okay, Got it\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center items-center space-x-2"
  }, [_c('span', {
    staticClass: "font-poppins text-gray-800"
  }, [_vm._v("Do not show this anymore")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.not_show_heads_up_info),
      expression: "not_show_heads_up_info"
    }],
    staticClass: "cursor-pointer",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.not_show_heads_up_info) ? _vm._i(_vm.not_show_heads_up_info, null) > -1 : (_vm.not_show_heads_up_info)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.not_show_heads_up_info,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.not_show_heads_up_info = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.not_show_heads_up_info = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.not_show_heads_up_info = $$c
        }
      }
    }
  })])])])])] : _vm._e(), _vm._v(" "), (_vm.show_delete_point_modal) ? [_c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "title": "Delete Criteria Point",
      "size": "confirm_size"
    },
    on: {
      "close": _vm.closeDeletePointModal
    }
  }, [_c('div', {
    staticClass: "h-full w-full overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex flex-col h-full pb-5"
  }, [_c('div', {
    staticClass: "overflow-y-auto h-full px-6 mb-4"
  }, [_c('div', {
    staticClass: "text-gray-900 font-poppins font-light"
  }, [_vm._v("\n              You are deleting this criteria point from this roundtable. This action cannot be undone.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col px-5 flex-grow h-full"
  }, [_c('div', {
    staticClass: "flex flex-col w-full space-y-1.5 mb-2"
  }, [_c('span', {
    staticClass: "font-poppins text-gray-900"
  }, [_vm._v("Please type in \"confirm\" to delete")]), _vm._v(" "), _c('input', {
    ref: "confirm-input",
    staticClass: "py-2 px-3 w-full border border-solid border-gray-200 bg-white rounded-md focus-within:border-red-500",
    attrs: {
      "placeholder": "Type 'confirm' to delete roundTable from the course",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmDeleteAssessmentPoint()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "hover:bg-gray-50 bg-white py-2 flex items-center justify-center space-x-2 text-blueGray-500 font-medium w-full rounded-md border border-solid border-gray-200",
    on: {
      "click": function($event) {
        _vm.show_delete_point_modal = false
      }
    }
  }, [_c('span', [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "bg-red-500 transition-colors py-2 flex items-center justify-center space-x-2 text-red-50 font-semibold w-full rounded-md border border-solid border-red-500",
    on: {
      "click": _vm.confirmDeleteAssessmentPoint
    }
  }, [_c('span', [_vm._v("Confirm")])])])])])])])] : _vm._e(), _vm._v(" "), (_vm.show_integrations_modal) ? _c('connect-integrations-assessment-modal', {
    on: {
      "close": function($event) {
        _vm.show_integrations_modal = false
      },
      "goToInviteStudents": function($event) {
        _vm.isInviteStudentModalOpen = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sync_assessment) ? _c('sync-assessment-data-modal', {
    attrs: {
      "selectedIntegration": _vm.selected_integration,
      "activityType": 'verbal',
      "edLink": _vm.edLink,
      "logo": _vm.logo
    },
    on: {
      "close": function($event) {
        _vm.sync_assessment = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalSampleOpen) ? _c('ModalSampleRoundTable', {
    attrs: {
      "dataSample": _vm.urlVideoSample
    },
    on: {
      "close": function($event) {
        _vm.isModalSampleOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_edit_lrt_modal === true) ? _c('EditVerbalDiscussion', {
    attrs: {
      "id": _vm.getCurrentDiscussion.id
    },
    on: {
      "close": function($event) {
        _vm.show_edit_lrt_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.switch_moderator) ? _c('moderator-modal', {
    attrs: {
      "participationID": _vm.participationID,
      "user_moderator": _vm.user_moderator
    },
    on: {
      "close": function($event) {
        _vm.switch_moderator = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInviteStudentModalOpen) ? _c('InviteStudents', {
    on: {
      "close": function($event) {
        _vm.isInviteStudentModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_new_roundtable_open) ? _c('NewRoundTable', {
    attrs: {
      "outside_option": _vm.outside_option,
      "follow_up_from": _vm.getCurrentDiscussion
    },
    on: {
      "close": function($event) {
        _vm.is_new_roundtable_open = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.templates_modal) ? _c('TemplatesModal', {
    attrs: {
      "activityType": 'verbal'
    },
    on: {
      "close": _vm.closeTemplateModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_confirm_settings_modal_open === true) ? _c('SaveSettingsModal', {
    on: {
      "close": function($event) {
        _vm.is_confirm_settings_modal_open = false
      },
      "handleSaveLDSettings": _vm.saveSettingsTab
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isStartDiscussionModalOpen === true) ? _c('MDStartDiscussion', {
    on: {
      "close": function($event) {
        _vm.isStartDiscussionModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEndDiscussionModalOpen === true) ? _c('MDEndDiscussion', {
    on: {
      "close": function($event) {
        _vm.isEndDiscussionModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isToShowPolls) ? _c('div', [(_vm.isToShowPolls) ? _c('Polls', {
    attrs: {
      "showPage": true
    },
    on: {
      "close": function($event) {
        _vm.isToShowPolls = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isToShowPolls) ? _c('NewPoll', {
    attrs: {
      "showPage": false
    },
    on: {
      "close": function($event) {
        _vm.isToShowPolls = false
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isToShowCriteria) ? _c('LDViewCriteria', {
    on: {
      "close": function($event) {
        _vm.isToShowCriteria = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasTeacherPermissionsInCourse && !_vm.isToShowPolls) ? _c('NewPoll', {
    attrs: {
      "showPage": false,
      "realTimeVote": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isToShowGuidingQuestions && _vm.hasTeacherPermissionsInCourse) ? _c('GuidingQuestions', {
    on: {
      "close": function($event) {
        _vm.isToShowGuidingQuestions = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_course_chat) ? _c('ChatBox', {
    on: {
      "message_notifications_val": _vm.handleUpdateUnreadMessages,
      "close": _vm.handleChangeChatStatus
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowLeaveModal === true) ? _c('LeaveModal', {
    on: {
      "close": function($event) {
        _vm.isShowLeaveModal = false
      },
      "confirm_accepted": function($event) {
        return _vm.handleConfirmLeave()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFollowUpQuestionsModalOpen === true) ? _c('GenieRecapQuestionsModal', {
    on: {
      "close": function($event) {
        _vm.isFollowUpQuestionsModalOpen = false
      },
      "followUpQuestions": _vm.followUpQuestionsCurrent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_live_rt_modal === true) ? _c('DeleteRoundtableModal', {
    attrs: {
      "roundtable_id": _vm.getCurrentDiscussion.id,
      "roundtable_name": _vm.getCurrentDiscussion.title
    },
    on: {
      "delete_roundtable": function (roundtable_id) { return _vm.deleteLiveRoundtable(roundtable_id); },
      "close": function($event) {
        _vm.show_delete_live_rt_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_export_data_modal) ? _c('ExportEngagementDataModal', {
    attrs: {
      "fileName": _vm.exportable_file_name,
      "getFile": _vm.fetchClassCSVdata,
      "showButtons": Boolean(_vm.getCurrentDiscussion.participations.length)
    },
    on: {
      "close": function($event) {
        _vm.show_export_data_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_to_remove_roundtable_from_sequence === true) ? _c('RemoveRoundTableSequence', {
    attrs: {
      "roundtable_name": _vm.getCurrentDiscussion.title,
      "sequence_name": "Exemplo nome de Sequence"
    },
    on: {
      "close": function($event) {
        _vm.is_to_remove_roundtable_from_sequence = false
      },
      "confirm_remove_sequence": function () { return _vm.handleRemoveRoundTableSequence(); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFollowUpOpen === true) ? _c('Draft', {
    attrs: {
      "id": _vm.selectedRoundTableToFollow.draftId,
      "type": _vm.selectedRoundTableToFollow.type,
      "isFollowUp": true
    },
    on: {
      "close": function($event) {
        _vm.isFollowUpOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isToShowEditWordCloud === true) ? _c('EditVRWordCloud', {
    attrs: {
      "keywordData": _vm.keywordData
    },
    on: {
      "close": function($event) {
        _vm.isToShowEditWordCloud = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.showGeniePopover && _vm.getCourseDetail.id !== '151035ea-b4c7-484d-a07d-3505fa895cf7') ? _c('div', {
    staticClass: "fixed bottom-4 z-40 shadow-xl rounded-lg bg-white border border-solid border-gray-200 w-96 transition-all duration-1000 ease-in-out transform",
    class: {
      'opacity-100 scale-100': _vm.showGeniePopover,
      'opacity-0 scale-75': !_vm.showGeniePopover
    },
    staticStyle: {
      "left": "65px"
    }
  }, [_c('div', {
    staticClass: "flex flex-col space-y-5 px-5 pt-2.5 pb-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5"
  }, [_c('i', {
    staticClass: "fa-regular fa-lightbulb text-base text-yellow-500"
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-poppins font-semibold text-gray-800"
  }, [_vm._v("Parlay Tip")])]), _vm._v(" "), _c('button', {
    staticClass: "w-8 h-8 rounded-full hover:bg-gray-100 hover:text-primary",
    on: {
      "click": function($event) {
        return _vm.handleCloseGeniePopover()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-xmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "w-full relative"
  }, [(_vm.genie_teaching_page === 1) ? _c('img', {
    attrs: {
      "src": "/static/transcription_teaching1.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.genie_teaching_page === 2) ? _c('img', {
    attrs: {
      "src": "/static/transcription_teaching2.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.genie_teaching_page === 3) ? _c('img', {
    attrs: {
      "src": "/static/transcription_teaching3.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [(_vm.genie_teaching_page === 1 || _vm.genie_teaching_page === 3) ? _c('h4', {
    staticClass: "font-poppins font-semibold text-base text-gray-800"
  }, [_vm._v("\n          Have you tried Transcription yet?\n        ")]) : _c('h4', {
    staticClass: "font-poppins font-semibold text-base text-gray-800"
  }, [_vm._v("\n          This makes it easy to remember who said what in the RoundTable.\n        ")]), _vm._v(" "), (_vm.genie_teaching_page === 1) ? _c('p', {
    staticClass: "font-poppins font-light text-gray-600"
  }, [_vm._v("\n          This feature will transcribe each student's speaking turn and then generate a summary, follow up questions and a word cloud!\n        ")]) : (_vm.genie_teaching_page === 2) ? _c('p', {
    staticClass: "font-poppins font-light text-gray-600"
  }, [_vm._v("\n          It will ask for access to each student's microphone when they tap in for the first time.\n        ")]) : (_vm.genie_teaching_page === 3) ? _c('p', {
    staticClass: "font-poppins font-light text-gray-600"
  }, [_vm._v("\n          Turn Transcription "), _c('span', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("ON")]), _vm._v("\n          in your Settings.\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('button', {
    staticClass: "w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200",
    attrs: {
      "disabled": _vm.genie_teaching_page <= 1
    },
    on: {
      "click": function($event) {
        return _vm.handleChangePageTeaching('back')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "w-3 h-3 rounded-full bg-blueGray-500",
    class: {
      'bg-blueGray-800': _vm.genie_teaching_page === 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-3 h-3 rounded-full bg-blueGray-500",
    class: {
      'bg-blueGray-800': _vm.genie_teaching_page === 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-3 h-3 rounded-full bg-blueGray-500",
    class: {
      'bg-blueGray-800': _vm.genie_teaching_page === 3
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200",
    attrs: {
      "disabled": _vm.genie_teaching_page >= 3
    },
    on: {
      "click": function($event) {
        return _vm.handleChangePageTeaching('next')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-chevron-right"
  })])])])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-91ebcdce!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/liveDiscussion.vue
// module id = 1911
// module chunks = 61